import React from 'react';
import DoubleInput from '../../../../../../../components/NovoSistema/DoubleInput';
import ButtonsSearch from '../../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../../components/NovoSistema/ContainerSection';
import InputDate from '../../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function EntradaSearch() {
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisa</h3>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="Emitida por"
            id="EmitidaPor"
            optionsArray={['', 'Matriz/Filial', 'Terceiros']}
            widthPercentage="20%"
          />
          <InputText title="Nº Docto" id="NDocto" widthPercentage="20%" />
          <SelectAndOptions
            title="Documento Fiscal"
            id="DocumentoFiscal"
            optionsArray={[
              '',
              '1  | NF    | Nota Fiscal',
              '1B | NFA   | Nota Fiscal Avulsa',
              '2  | NFVC  | Nota Fiscal Venda Consumidor',
              '2D | CFECF | Cupom Fiscal - ECF',
              '4  | NFP   | Nota Fiscal Produtor',
              '55 | NFE   | Nota Fiscal Eletrônica',
              '57 | CTE   | Conhecimento de Transporte Eletrônico',
              '59 | CFE   | Cupom Fiscal Eletrônico - SAT',
              '65 | NFCE  | Nota Fiscal Eletrônica ao Consumidor Final - NFC-e',
              '100 | NFS  | Nota Fiscal Serviço',
              '101 | NFFS | Nota Fiscal Fatura de Serviços',
              '104 | M01F | Nota Fiscal Fatura (Modelo 1)',
              '106 | RS | Recibo de Serviço',
            ]}
            widthPercentage="20%"
          />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <DoubleInput title="Parceiro de Negócios/Empresa" id="ParceiroDeNegociosEmpresas" widthPercentage="40%" />
          <SelectAndOptions
            title="Tipo de Pessoa"
            id="TipoDePessoa"
            optionsArray={['', 'Física', 'Jurídica']}
            widthPercentage="20%"
          />
          <InputText title="CNPJ/CPF" id="CNPJCPF" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputDate title="Entrada Inicial" id="EntradaInicial" widthPercentage="20%" />
          <InputDate title="Entrada Final" id="EntradaFinal" widthPercentage="20%" />
          <InputDate title="Emissão Inicial" id="EmissaoInicial" widthPercentage="20%" />
          <InputDate title="Emissão Final" id="EmissaoFinal" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <DoubleInput title="Produto" id="Produto" widthPercentage="40%" />
          <SelectAndOptions
            title="Conferida"
            id="Conferida"
            optionsArray={['Todas', 'Sim', 'Não']}
            widthPercentage="20%"
          />
        </WrapperInputsNewSystem>
        <ButtonsSearch />
      </ContainerSection>
    </div>
  );
}
